import React from 'react';
import { connect } from 'react-redux';

import SettingsGroup from 'components/Shared/SettingsGroup';
import If from 'components/Shared/If';
import { ContentSet, FlexRow } from 'components/Shared/Scaffolding';
import {
    CardWrapper,
    CardSection,
    CardToolbar,
    CardTool,
    CardIcon,
    PreviewRow,
    PreviewImage,
    PreviewDesc,
} from 'components/Shared/Cards';
import { GLYPHS } from 'components/Shared/Icon';
import { showModal } from 'modules/modal';
import MODAL from 'components/Shared/Modals';
import { getStyle } from 'modules/style';

const Preview = ({ style, onCardClick, onRemoveStyle, className, labelClassName, contentClassName }) => {
    const hasStyle = style && style.id;
    return (
        <SettingsGroup
            name="Style"
            description="Choose a style for your map"
            className={className}
            labelClassName={labelClassName}
            contentClassName={contentClassName}
        >
            <ContentSet>
                <If statement={hasStyle}>
                    <CardWrapper>
                        <CardSection onClick={onCardClick}>
                            <FlexRow alignCenter>
                                <PreviewImage img={style.imageUrl} />
                                <PreviewDesc hasPreview={hasStyle}>
                                    <strong>{style.name}</strong>
                                    <em>by {style.createdBy}</em>
                                </PreviewDesc>
                                <CardIcon primary glyph={GLYPHS.SEARCH} />
                            </FlexRow>
                        </CardSection>
                        <CardToolbar>
                            <CardTool
                                title="View Style Details"
                                href={style.url}
                                glyph={GLYPHS.OPEN_IN_NEW}
                                target="_blank"
                                rel="noopener noreferrer"
                            />
                            <CardTool
                                title="Remove style"
                                right
                                glyph={GLYPHS.REMOVE_OUTLINE}
                                onClick={onRemoveStyle}
                            />
                        </CardToolbar>
                    </CardWrapper>
                </If>
                <If statement={!hasStyle}>
                    <CardWrapper onClick={onCardClick}>
                        <PreviewRow>
                            <CardIcon glyph={GLYPHS.SNAZZY_MAPS_OUTLINE} />
                            <PreviewDesc hasPreview={hasStyle}>Choose a Snazzy Maps style</PreviewDesc>
                            <CardIcon primary glyph={GLYPHS.CHEVRON_RIGHT} />
                        </PreviewRow>
                    </CardWrapper>
                </If>
            </ContentSet>
        </SettingsGroup>
    );
};

const mapStateToProps = (state) => ({
    style: getStyle(state),
});

const mapDispatchToProps = (dispatch) => ({
    onRemoveStyle: () => {
        dispatch(showModal(MODAL.CONFIRM_STYLE_REMOVE));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Preview);
